module.exports = __webpack_public_path__ + "04_short_gold.368fa647.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_short_gold.png
// module id = OpSs
// module chunks = 0